import { render, staticRenderFns } from "./BsTabLabel.vue?vue&type=template&id=4a0e9a68&scoped=true&"
import script from "./BsTabLabel.vue?vue&type=script&lang=js&"
export * from "./BsTabLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e9a68",
  null
  
)

export default component.exports